module.exports = "/_next/static/images/TrialToPaidConversionMobile-918a82a6ec47c7e1a8abab9f750a9def.webp";